<script setup>
import { useLayouts } from '@layouts'

import { useUsersStore } from '@/stores'
import {storeToRefs} from "pinia"
const props = defineProps({
  navItems: {
    type: null,
    required: true
  }
})
const usersStore = useUsersStore()
const {y: windowScrollY} = useWindowScroll()
const {
  _layoutClasses: layoutClasses,
  isNavbarBlurEnabled
} = useLayouts()
const {width: windowWidth} = useWindowSize()
const router = useRouter()
const shallShowPageLoading = ref(false)
router.beforeEach(() => {
  shallShowPageLoading.value = true
})
router.afterEach(() => {
  shallShowPageLoading.value = false
})

let myUser = null;
({ myUser } = storeToRefs(usersStore))
</script>

<template>
  <div
    class="layout-wrapper"
    :class="layoutClasses(windowWidth, windowScrollY)"
  >
    <div
      class="layout-navbar-and-nav-container"
      :class="isNavbarBlurEnabled && 'header-blur'"
    >
      <!-- 👉 Navbar -->
      <div class="layout-navbar">
        <div class="navbar-content-container">
          <!--
            <slot
            name="navbar"
            :toggleVerticalOverlayNavActive="toggleVerticalOverlayNavActive"
            />
          -->
          <slot name="navbar" />
        </div>
      </div>
    </div>

    <main class="layout-page-content">
      <template v-if="$slots['content-loading']">
        <template v-if="shallShowPageLoading">
          <slot name="content-loading" />
        </template>
        <template v-else>
          <slot />
        </template>
      </template>
      <template v-else>
        <slot />
      </template>
    </main>

    <!-- 👉 Footer -->
    <footer class="layout-footer">
      <div class="footer-content-container">
        <slot name="footer" />
      </div>
    </footer>
  </div>
</template>

<style lang="scss">
@use "@configured-variables" as variables;
@use "@layouts/styles/placeholders";
@use "@layouts/styles/mixins";

.layout-wrapper {
  &.layout-nav-type-horizontal {
    display: flex;
    flex-direction: column;

    // // TODO(v2): Check why we need height in vertical nav & min-height in horizontal nav
    // min-height: 100%;
    min-block-size: calc(var(--vh, 1vh) * 100);

    .layout-navbar-and-nav-container {
      z-index: 1;
    }

    // 👉 Navbar
    .navbar-content-container {
      @include mixins.boxed-content;
    }

    /*
      ℹ️ This style will allow creating scrollable content within available space.
      However, this style is producing bugs when `display: flex` element is direct child of it.
      e.g. Gamification page
    */
    // .layout-page-content {
    //   display: flex;
    //   flex-direction: column;
    // }

    // 👉 Footer
    // Boxed content
    .layout-footer {
      .footer-content-container {
        @include mixins.boxed-content;
      }
    }
  }

  // If both navbar & horizontal nav sticky
  &.layout-navbar-sticky.horizontal-nav-sticky {
    .layout-navbar-and-nav-container {
      position: sticky;
      inset-block-start: 0;
      will-change: transform;
    }
  }

  &.layout-navbar-hidden.horizontal-nav-hidden {
    .layout-navbar-and-nav-container {
      display: none;
    }
  }

  .layout-navbar {
    z-index: variables.$layout-horizontal-nav-layout-navbar-z-index;
    block-size: variables.$layout-horizontal-nav-navbar-height;

    // ℹ️ For now we are not independently managing navbar and horizontal nav so we won't use below style to avoid conflicting with combo style of navbar and horizontal nav
    // If we add independent style of navbar & horizontal nav then we have to add :not for avoiding conflict with combo styles
    // .layout-navbar-sticky & {
    //   @extend %layout-navbar-sticky;
    // }

    // ℹ️ For now we are not independently managing navbar and horizontal nav so we won't use below style to avoid conflicting with combo style of navbar and horizontal nav
    // If we add independent style of navbar & horizontal nav then we have to add :not for avoiding conflict with combo styles
    // .layout-navbar-hidden & {
    //   @extend %layout-navbar-hidden;
    // }
  }

  &.layout-nav-type-horizontal {
    // 👉 Content height fixed
    &.layout-content-height-fixed {
      max-block-size: calc(var(--vh) * 100);

      .layout-page-content {
        overflow: hidden;

        > :first-child {
          max-block-size: 100%;
          overflow-y: auto;
        }
      }
    }
  }
}

// 👉 Horizontal nav nav
.layout-horizontal-nav {
  z-index: variables.$layout-horizontal-nav-z-index;

  // .horizontal-nav-sticky & {
  //   width: 100%;
  //   will-change: transform;
  //   position: sticky;
  //   top: 0;
  // }

  // .horizontal-nav-hidden & {
  //   display: none;
  // }

  .horizontal-nav-content-container {
    @include mixins.boxed-content(true);
  }
}
</style>
